import { equalCols, initMap } from '../functions';

function initSelect2ForMobile() {
    if (window.innerWidth < 768) {
        if (!$('.search-select-location').hasClass('select2-hidden-accessible')) {
            $('.search-select-location').select2({
                minimumResultsForSearch: -1,
                width: '100%',
            });
        }
    } else {
        if ($('.search-select-location').hasClass('select2-hidden-accessible')) {
            $('.search-select-location').select2('destroy');
        }
    }
}

initSelect2ForMobile();
window.addEventListener('resize', initSelect2ForMobile);

$(document).ready(function () {

	if($('#contact-map').length > 0) {
		initMap('contact-map');
	}

	$('.date-picker').datepicker({
        autoclose: true
    });

    $('.custom-select').select2({
        // theme: "classic"
		minimumResultsForSearch: -1,
    });

    $('.countries-select').select2({
        // theme: "classic"
		minimumResultsForSearch: 1,
    });

    $('.select-birthday').select2({
        // theme: "classic"
		minimumResultsForSearch: 1,
    });

    $('#driver-age').select2({
        // theme: "classic"
		minimumResultsForSearch: -1,
		placeholder: $('#driver-age').attr('placeholder'),
    });

    $('#input_class').select2({
        // theme: "classic"
		minimumResultsForSearch: -1,
    });


    $('.custom-select.select-location').select2({
        // theme: "classic"
        placeholder: '<i class="far fa-square"></i>Branch name',
        escapeMarkup : function(markup) {
            return markup;
        }
    });

    if ( $('#player').length > 0 ) {
        const player = new Plyr(document.getElementById('player', {
            controls: ['play-large'],
            loop: true,
            ratio: '16:9'
        }));
    }


    $(".scroll-to-module").on('click', function(event) {

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top - 30
        }, 250);
    });

    // Add smooth scrolling to all links
    $(".scroll-to").on('click', function(event) {

        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
            scrollTop: $(hash).offset().top
        }, 800, function(){

            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
        });
        } // End if
    });

    $('.hamburger').click(function(e) {
        e.preventDefault()
        // $(this).toggleClass('is-active');
    });

    $('.btn-toggle').click(function(e) {
        e.preventDefault();
		e.stopPropagation();
        var toggleBox = $(this).attr('data-target');
        $(toggleBox).toggleClass('active');
    });

    $('.price-options-overlay a').click(function(e) {
        e.preventDefault();
        var toggleOption = $(this).attr('data-target');
        var toggleHtml = $(this).attr('data-content')

		if ($(this).hasClass('open')) {
			$(this).removeClass('open');
			$(toggleOption).removeClass('active');
			$(toggleOption).children('.price-info-overlay--content')[0].innerText = '';
			return false;
		}

		if ($(this).parent().parent().find(".open").length > 0) {
			$(this).parent().parent().find(".open").removeClass('open');
			$(toggleOption).removeClass('active');
			$(toggleOption).children('.price-info-overlay--content')[0].innerText = '';
		}

		$(this).addClass('open');
        $(toggleOption).addClass('active');
        $(toggleOption).children('.price-info-overlay--content')[0].innerText = toggleHtml;
    });

	$(document).on('click', '.price-options-item--link', function() {
		$(this).parent().parent().find('.price-options-overlay').removeClass('active');
		$(this).parent().find('.price-options-overlay').addClass('active');
	});
	$(document).on('click', '.btn-close-price-option-overlay', function() {
		$(this).parent().removeClass('active');
	});

    $(document).on('click', '.btn-group-go-top', function(e) {
        e.preventDefault();

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });

    // BACK TO TOP
    window.onscroll = function() {
        if (document.body.scrollTop > 75 || document.documentElement.scrollTop > 75) {
            // $('.btn-top').addClass('active');
          } else {
            // $('.btn-top').removeClass('active');
        }
    };
    // BACK TO TOP
    // $('.datepicker').pickadate({
    //     labelMonthNext: 'Go to the next month',
    //     labelMonthPrev: 'Go to the previous month',
    //     labelMonthSelect: 'Pick a month from the dropdown',
    //     labelYearSelect: 'Pick a year from the dropdown',
    //     selectMonths: true,
    //     selectYears: true,
    //     formatSubmit: 'yyyy-mm-dd',
    // })
});

//old code
/*
$(document).ready(function() {

	if ($('.boxes-about-us-wrapper').length > 0) {
		$('.boxes-about-us-row').each(function(elem) {
			let id = $(this).data('id');
			equalCols('.equal-height-' + id);
		});
	}
	if ($('.ritchtext-template-1').length > 0) {
		if($(window).width() > 990) {
			equalCols('.equal-height');
		}
	}

    $('.btn_cookies').click(function() {
        var values;
        $.ajax({
            type: "GET",
            url: baseURL + "/accept-cookies-policy",
            data: values,
            success: function(html) {
                $('.box_cookies').hide();
            }
        });
    });

	$('.form-customer .form-check').click(function(){
        $('.form-customer .form-check').removeClass("selected");
        $('.form-customer .form-check-input').prop('checked', false);
        $(this).addClass("selected");
        $(this).find(".form-check-input").prop('checked', true);
    });

    $('.form-emailPreference .form-check').click(function(){
        $(this).toggleClass("selected-checkbox");
    });

    $(".hamburger").click(function(){
        $(".menu-mobile").toggleClass("opened");
        $(".overlay-mobile").toggleClass("opened");
        $("body").addClass("overflow");
    });

    $(".menu-mobile .close").click(function(){
        $(".menu-mobile").toggleClass("opened");
        $(".overlay-mobile").toggleClass("opened");
        $("body").removeClass("overflow");
    });

    $(".btn-menu-account").click(function(){
        $(".account-menu-column").addClass("opened");
        $(".overlay-mobile").toggleClass("opened");
    });
    $(".account-menu-column .closebtn").click(function(){
        $(".account-menu-column").removeClass("opened");
        $(".overlay-mobile").toggleClass("opened");
    });

	$('.box-benefit-show-info').mouseenter(function() {
									$('.box-benefit-item').not(this).removeClass('active');
									$(this).toggleClass('active');
								})
								.mouseleave(function() {
									$('.box-benefit-item').removeClass('active');
								});

	$(document).on('click', '.mobile-has-submenu', function() {
		$(this).parent().find('.mobile-sub-menu').toggleClass('active');
	});
});
*/



// WEBPACK FOOTER //
// ./resources/assets/js/regular/javascript.js